<template lang="html">
  <div>
    <div class="t-shadow">
      <textarea
        ref="msg_textarea"
        v-model="message_text"
        class="message"
        placeholder="Type a new message..."
        :style="`cursor: ${readonly?'default;':''};`"
        :readonly="readonly"
        />
        <v-btn @click="sendMessage()" class="send-button pull-right">Send</v-btn>
        <div class="clear mb-1"></div>
      </div>
      <div class="users_popup">
        <StandardMembersList
          v-if="show_users"
          @selectIndex="selectIndex($event)"
          :members="filtered_users"
          :selected_index="selected_index"
          :current_user="current_user"
        />
      </div>
  </div>
</template>

<script>
import StandardMembersList from '@/components/StandardComponents/StandardMembersList.component.vue';
export default {
  props: ['readonly', 'context_users', 'current_user', 'twork_package', 'project', 'business'],
  components: { StandardMembersList },
  data: function () {
    return {
      show_users: false,
      message_text: '',
      selected_index: 0,
      filtered_users: [],
      current_word: '',
      block_listen: false,
      coded_users: [],
      coded_projects: [],
      coded_businesses: [],
      coded_twork_packages: []
    }
  },
  watch: {
    message_text(val){
      let cursor_pos = this.$refs.msg_textarea.selectionStart;
      // val has to be at least 2 characters
      if (this.block_listen) {
        this.block_listen = false;
      } else {
        if (val.length > 1) {
          let next_space = val.indexOf(' ', cursor_pos);
          let previous_space = val.lastIndexOf(' ', cursor_pos -1);
          if (previous_space ===  -1 && next_space === -1) {
            this.current_word = val;
          }
          if (previous_space >= 0 && next_space === -1) {
            this.current_word = val.substr(previous_space + 1);
          }
          if (previous_space >= 0 && next_space >= 0) {
            this.current_word = val.substr(previous_space + 1, next_space - previous_space - 1);
          }
          if (this.current_word.startsWith('@') && this.current_word.length > 1) {
            this.show_users = true;
            this.filtered_users = this.context_users.filter(user => user.first_name.toLowerCase().startsWith(this.current_word.substr(1).toLowerCase()) && user.id !== this.current_user.id );

            if (
              this.project && this.project.name.toLowerCase().startsWith(this.current_word.substr(1).toLowerCase()) ||
              this.project && 'project'.startsWith(this.current_word.substr(1).toLowerCase())
            ) {
              this.filtered_users.push({
                first_name: this.project.name,
                last_name: '(Project)',
                image: this.project.image,
                id: this.project.id
              });
            }

            if (this.business && this.business.name.toLowerCase().startsWith(this.current_word.substr(1).toLowerCase())) {
              this.filtered_users.push({
                first_name: this.business.name,
                last_name: '(Company)',
                image: 'noimage',
                id: this.business.id
              });
            }

            if (
              this.twork_package && this.twork_package.name.toLowerCase().startsWith(this.current_word.substr(1).toLowerCase()) ||
              this.twork_package && 'workpackage'.startsWith(this.current_word.substr(1).toLowerCase())
            ) {
              this.filtered_users.push({
                first_name: this.twork_package.name,
                last_name: '(Work Package)',
                image: 'noimage',
                id: this.twork_package.id
              });
            }

          } else {
            this.show_users = false;
          }
        } else {
          this.show_users = false;
        }
      }
    }
  },
  methods: {
    selectIndex(index){

      let item = this.filtered_users[index];

      this.block_listen = true;
      this.message_text = this.message_text.replace(
        this.current_word,
        '@' + item.first_name + ' '
      );
      if (item.last_name === '(Project)') {
        this.coded_projects.push(item);
      } else if (item.last_name === '(Company)') {
        this.coded_businesses.push(item);
      } else if (item.last_name === '(Work Package)') {
        this.coded_twork_packages.push(item);
      } else {
        this.coded_users.push(item);
      }
      this.show_users = false;
      this.$refs.msg_textarea.focus();
    },
    sendMessage(){
      this.$emit('sendMessage', {
        text: JSON.parse(JSON.stringify(this.message_text)),
        type: 'notification',
        users: this.coded_users,
        projects: this.coded_projects,
        businesses: this.coded_businesses,
        twork_packages: this.coded_twork_packages
      });
    },
    clearMessageText(){
      this.show_users = false;
      this.message_text = '';
      this.selected_index = 0;
      this.filtered_users = [];
      this.coded_users = [];
      this.coded_projects = [];
      this.coded_businesses = [];
      this.coded_twork_packages = [];
    }
  }
}
</script>

<style lang="css" scoped>
.message {
  width: 100%;
  background-color: snow;
  border-radius: 5px;
  padding: 3px;
}
.users_popup {
  margin-top: 5px;
  width: 60%;
  overflow-y: scroll;
  max-height: 230px;
}
.send-button {
  color: black;
  background-color: white !important;
}
</style>
